import { signal } from "@angular/core";
import { SchemaPathTree } from "@angular/forms/signals";
import { EVEstateType } from "src/models/units/unit-attributes.model";

export interface EstateTypeModel {
    estateType: EVEstateFilterType;
    index: number;
    selected: boolean;
    other: boolean;
}

export enum EVEstateFilterType {
    Ukjent = "Ukjent",
    Enebolig = "Enebolig",
    Rekkehus = "Rekkehus",
    Leilighet = "Leilighet",
    Hybel = "Hybel",
    Fritidsbolig = "Fritidsbolig",
    Tomannsbolig = "Tomannsbolig",
    Boligtomt = "Boligtomt",
    Hyttetomt = "Hyttetomt",
    Skole = "Skole/barnehage",
    Næring = "Næring",
    Landbruk = "Landbruk",
    Bolig = "Bolig",
    Hus = "Hus",
    DeltBolig = "Delt bolig",
    Garasje = "Garasje",
    Ubebygd = "Ubebygd",
    Offentlig = "Offentlig",
    Helse = "Helse",
    MediaKomm = "Media/komm",
    KulturIdrett = "Kultur og idrett",
    Religion = "Religion",
    Transport = "Transport",
    Annet = "Annet",
}

export const defaultEstateTypes: EstateTypeModel[] = [
    {
        estateType: EVEstateFilterType.Leilighet,
        index: EVEstateType.Leilighet,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Enebolig,
        index: EVEstateType.Enebolig,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Rekkehus,
        index: EVEstateType.Rekkehus,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Tomannsbolig,
        index: EVEstateType.Tomannsbolig,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Fritidsbolig,
        index: EVEstateType.Fritidsbolig,
        selected: false,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Annet,
        index: EVEstateType.Annet,
        selected: false,
        other: true,
    },
];

export interface EstateTypesFilterModel {
    estateTypes: EstateTypeModel[];
    expanded: boolean;
}

export function createEstateTypesModel() {
    return signal<EstateTypesFilterModel>({
        estateTypes: defaultEstateTypes,
        expanded: true,
    });
}

export function buildEstateTypesModel(a: SchemaPathTree<EstateTypesFilterModel>) {}
